module.exports = __webpack_public_path__ + "media/app_search/FreeTrialExtend/images/clients/client-icon-javascript-de79c8f14c2b0d692ae215d7e6eccd54.svg";